import { getApiUrl } from "Infrastructure/Api/Api";
import { useMarketNavigate } from "Infrastructure/Routes/Hooks/useMarketNavigate";
import { useMarketListQuery } from "Market/Api/Query/useMarketListQuery";
import { useMarket } from "Market/Providers/CurrentMarketProvider";
import { MarketPaths } from "Market/Routes/Routing";
import { OrderPaths } from "Order/Routes/Routing";
import { Flag, OutlinedFlag } from "@mui/icons-material";
import {
	Avatar,
	IconButton,
	Menu,
	MenuItem,
	Skeleton,
	Stack,
	Typography,
} from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router";

export const Market = () => {
	const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
	const open = Boolean(anchorEl);
	const marketNavigate = useMarketNavigate();
	const navigate = useNavigate();
	const { data: markets, isLoading: isLoadingMarkets } = useMarketListQuery();

	const { market, isLoading } = useMarket();

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	return (
		<>
			{isLoading ? (
				<>
					<Skeleton variant="circular" width={40} height={40} />
				</>
			) : (
				<>
					<IconButton
						aria-label="more"
						id="long-button"
						aria-controls={open ? "long-menu" : undefined}
						aria-expanded={open ? "true" : undefined}
						aria-haspopup="true"
						onClick={handleClick}
					>
						{market ? (
							market.iconPath ? (
								<Avatar
									src={`${getApiUrl()}${market.iconPath}`}
									alt={market.country}
									sx={{ width: 20, height: 20 }}
								/>
							) : (
								<OutlinedFlag fontSize="small" />
							)
						) : (
							<Flag fontSize="small" />
						)}
					</IconButton>
					<Menu
						id="long-menu"
						anchorEl={anchorEl}
						open={open}
						onClose={handleClose}
						sx={{
							"& .MuiMenu-paper": {
								width: "200px",
							},
						}}
					>
						{isLoadingMarkets && <Skeleton />}
						{!isLoadingMarkets &&
							markets
								?.filter((m) => m.isActive)
								.map((market, index) => (
									<MenuItem
										key={index}
										sx={{ py: 2, px: 3 }}
										onClick={() => {
											marketNavigate(OrderPaths.Index.path, market.urlPath);
										}}
									>
										<Stack direction="row" spacing={1} alignItems="center">
											{market.iconPath ? (
												<Avatar
													src={`${getApiUrl()}${market.iconPath}`}
													alt={market.country}
													sx={{ width: 20, height: 20 }}
												/>
											) : (
												<OutlinedFlag fontSize="small" />
											)}
											<Typography> {market.name}</Typography>
										</Stack>
									</MenuItem>
								))}
						{/* All countries flag */}
						<MenuItem
							sx={{ py: 2, px: 3 }}
							onClick={() => {
								marketNavigate(OrderPaths.Index.path, "");
							}}
						>
							<Stack direction="row" spacing={1} alignItems="center">
								<Flag fontSize="small" />
								<Typography>All markets</Typography>
							</Stack>
						</MenuItem>
						{/* Show all button */}
						<MenuItem
							sx={{ py: 1, px: 3 }}
							onClick={() => {
								navigate(MarketPaths.Select.path);
							}}
						>
							<Stack
								direction="row"
								spacing={1}
								alignItems="center"
								justifyContent="center"
								width="100%"
							>
								<Typography>Show all</Typography>
							</Stack>
						</MenuItem>
					</Menu>
				</>
			)}
		</>
	);
};
